const addZendeskScript = () => {
  const script = document.createElement("script");
  script.id = "ze-snippet";
  script.src =
    "https://static.zdassets.com/ekr/snippet.js?key=565bdcc9-7483-4353-ad23-bc78c31d3647";
  script.async = true;
  document.body.appendChild(script);
};

export default addZendeskScript;
